import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import HelpIcon from "@mui/icons-material/Help";
import BlockIcon from "@mui/icons-material/Block";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const CheckListItemIcon = ({ status }) => {
  if (status === "unknown") {
    return <HelpIcon color="warning" />;
  }
  if (status === "not-applicable") {
    return <BlockIcon color="info" />;
  }
  if (status === "pendingApproval") {
    return <WarningIcon color="warning" />;
  }
  if (status === null) {
    return <PendingIcon color="disabled" />;
  }
  if (status) {
    return <CheckCircleIcon color="success" />;
  }
  return <CancelIcon color="error" />;
};
const CheckListManageButton = ({ link, text }) => {
  if (link.includes("#")) {
    return (
      <Button
        size="small"
        color="secondary"
        component={HashLink}
        to={link}
        scroll={(el) => {
          const yCoordinate =
            el.getBoundingClientRect().top + window.pageYOffset;
          const yOffset = -80;
          window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
        }}
      >
        {text}
      </Button>
    );
  }
  return (
    <Button size="small" color="secondary" component={Link} to={link}>
      {text}
    </Button>
  );
};
const getRowCls = (status) => {
  if (typeof status === "string") {
    return `checklist-row--${status}`;
  }
  if (status === null) {
    return `checklist-row--pending`;
  }
  if (status) {
    return `checklist-row--success`;
  }
  return `checklist-row--error`;
};
export const CheckListItemRow = ({
  status,
  label,
  tooltip,
  manageLink,
  manageText = "Manage",
  secondaryLink,
  secondaryLinkText,
}) => {
  return (
    <TableRow className={`checklist-row ${getRowCls(status)}`}>
      <TableCell sx={{ px: 0 }} width={32}>
        <CheckListItemIcon status={status} />
      </TableCell>
      <TableCell component="th" scope="row">
        {label}
        {tooltip && (
          <Tooltip disableFocusListener title={tooltip}>
            <HelpOutlineIcon color="info" fontSize={"16px"} sx={{ ml: 1 }} />
          </Tooltip>
        )}
      </TableCell>
      <TableCell sx={{ textAlign: "right" }}>
        {manageLink && (
          <CheckListManageButton text={manageText} link={manageLink} />
        )}
        {secondaryLink && (
          <CheckListManageButton
            text={secondaryLinkText}
            link={secondaryLink}
          />
        )}
      </TableCell>
    </TableRow>
  );
};
export const CheckListTable = ({ children }) => {
  return (
    <Table
      size="small"
      sx={{
        ".MuiTableCell-root": {
          borderColor: "neutral.200",
        },
        ".checklist-row--not-applicable": {
          opacity: 0.6,
        },
      }}
    >
      <TableBody>{children}</TableBody>
    </Table>
  );
};
export const CheckListActionRow = ({ children }) => {
  return (
    <TableRow>
      <TableCell colSpan={3} sx={{ px: 0 }}>
        {children}
      </TableCell>
    </TableRow>
  );
};
